import React, { useState, useMemo, useCallback, useEffect } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useIntl } from 'react-intl';
import { useMutation } from '@apollo/react-hooks';
import { ADD_USER_MESSAGE } from 'graphql/mutations/addUserMessage';
import { STATIC_SEO } from 'graphql/queries/seo';
import { useQuery } from '@apollo/react-hooks';
import { useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import ReCAPTCHA from 'react-google-recaptcha';
import {
  Title,
  Text,
  PageContainer,
  Input,
  Form,
  TextArea,
  Button,
  Map,
  Breadcrumb,
} from 'components';

import { Select, Row, Col, message } from 'antd';
import { ContainerInner, ContactSelectStyles } from './Contact.styles';

const { Option, OptGroup } = Select;
const key = 'updatable';

const Contact = () => {
  const history = useHistory();

  const [addUserMessage, { data, loading, error }] = useMutation(
    ADD_USER_MESSAGE
  );
    const [isCaptcaChecked, setCaptcaChecked] = useState(false);
  const {
    loading: loadingLanding,
    error: errorLanding,
    data: dataSeo,
  } = useQuery(STATIC_SEO, {
    variables: {
      url: `${history.location.pathname.slice(1)}/`,
    },
    fetchPolicy: 'network-only',
  });

  React.useEffect(() => {
    console.log('dataSeo: ', history.location.pathname.slice(1));
    console.log('dataSeo: ', dataSeo);
  }, [dataSeo]);

  const validationSchema = Yup.object().shape({
    name: Yup.string()
      .min(2, 'Must have a character')
      .max(255, 'Must be shorter than 255')
      .required('Required'),
    email: Yup.string()
      .min(1, 'Must have a character')
      .max(255, 'Must be shorter than 255')
      .required('Required'),
    subject: Yup.string().required('This field is required'),
    comments: Yup.string()
      .min(1, 'Must have a character')
      .max(255, 'Must be shorter than 255')
      .required('Required'),
  });

  const [placeMarkers, setPlaceMarkers] = useState([
    {
      type: 'Feature',
      properties: {
        PARK_ID: 960,
        FACILITYID: 28014,
        NAME: 'TEST VILLA',
        NAME_FR: 'Planchodrome Bearbrook',
        ADDRESS: '8720 Russell Road',
        ADDRESS_FR: '8720, chemin Russell',
        DESCRIPTIO: 'Flat asphalt surface, 5 components',
        DESCRIPT_1: "Surface d'asphalte plane, 5 modules",
      },
      geo: [40.59419, 22.96242],
    },
  ]);

  const intl = useIntl();

  useEffect(() => {
    if (loading) {
      return message.loading({
        content: intl.formatMessage({
          id: 'feedback.loading',
        }),
        key,
        className: 'custom-message-class',
      });
    }
    if (data) {
      return message.success({
        content: intl.formatMessage({
          id: 'feedback.success',
        }),
        key,
        duration: 3,
        className: 'custom-message-class',
      });
    }
    if (error) {
      return message.success({
        content: intl.formatMessage({
          id: 'feedback.error',
        }),
        key,
        duration: 3,
        className: 'custom-message-class',
      });
    }
  }, [loading, data, error]);

  function onChange(value) {
    // console.log('Captcha value:', value);
    setCaptcaChecked(true);
  }

  return (
    <>
      {dataSeo && (
        <Helmet>
          <title>{dataSeo.staticPage.seoMeta.seoTitle}</title>
          <meta
            name="description"
            content={dataSeo.staticPage.seoMeta.seoDescription}
          />
          <meta
            name="keywords"
            content={dataSeo.staticPage.seoMeta.seoKeywords}
          />
          <link rel="canonical" href="https://aktis.villas/en" />
        </Helmet>
      )}
      <PageContainer padding="80px 5.7vw 20px">
        <Map
          isPopup={false}
          width="100%"
          height="275px"
          heightSM="238px"
          places={placeMarkers}
        />
        <Title
          margin="30px 0 0 0"
          weight="500"
          size1100="24px"
          size="36px"
          alignTablet="center"
          ubuntu
        >
          {intl.formatMessage({
            id: 'contact.contact-us',
          })}
        </Title>
        <Row>
          <Col span={24} lg={14} md={14} sm={24}>
            <ContainerInner padding="0 80px 0 0" borderRight>
              <Text margin="20px 0" size="14px" lineHeight="143%" mutedText>
                {intl.formatMessage({
                  id: 'contact.contact-info',
                })}
              </Text>
              <Formik
                initialValues={{
                  name: '',
                  email: '',
                  subject: '',
                  comments: '',
                }}
                validationSchema={validationSchema}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                  /* Action here to submit */
                  /* Call Apollo Mutaion */
                  if(!isCaptcaChecked) {
                    return;
                  }
                  console.log(values);
                  addUserMessage({
                    variables: {
                      name: values.name,
                      subject: values.subject,
                      email: values.email,
                      lang: localStorage.language,
                      message: values.comments,
                    },
                  });
                  resetForm();
                }}
              >
                {({
                  values,
                  errors,
                  // touched,
                  handleChange,
                  handleBlur,
                  handleSubmit,
                  isSubmitting,
                }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row justify="space-between">
                      <Input
                        borderColor="#D7D6E0"
                        border
                        placeholderColor="grey"
                        borderRadius="10px"
                        width="48%"
                        widthSm="100%"
                        margin="0 0 30px 0"
                        padding="10px 20px"
                        // error={touched.name && errors.name}
                        // error={errors.name}
                        value={values.name}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="text"
                        name="name"
                        placeholder={intl.formatMessage({
                          id: 'forms.name',
                        })}
                      />
                      {/* <Error touched={touched.name} message={errors.name} /> */}

                      <Input
                        borderColor="#D7D6E0"
                        border
                        placeholderColor="grey"
                        borderRadius="10px"
                        width="48%"
                        widthSm="100%"
                        margin="0 0 30px 0"
                        padding="10px 20px"
                        // error={touched.email && errors.email ? 'has-error' : null}
                        // error={errors.email ? 'has-error' : null}
                        value={values.email}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        type="text"
                        name="email"
                        placeholder={intl.formatMessage({
                          id: 'forms.email',
                        })}
                      />
                      {/* <Error touched={touched.email} message={errors.name} /> */}
                      {/* <InputWrapperStyles width="100%" margin="0 0 30px 0"> */}
                      <ContactSelectStyles width="100%" margin="0 0 30px 0">
                        <Select
                          name="subject"
                          defaultValue={intl.formatMessage({
                            id: 'contact.subject',
                          })}
                          style={{ width: '100%' }}
                          onChange={(selectedOption) => {
                            let event = {
                              target: {
                                name: 'subject',
                                value: selectedOption,
                              },
                            };
                            handleChange(event);
                          }}
                        >
                          <Select.Option
                            style={{ fontSize: '16px' }}
                            value="searchVilla"
                          >
                            {intl.formatMessage({
                              id: 'contact.villa.search',
                            })}
                          </Select.Option>
                          <Select.Option
                            style={{ fontSize: '16px' }}
                            value="orderVilla"
                          >
                            {intl.formatMessage({
                              id: 'contact.villa.order',
                            })}
                          </Select.Option>
                          <Select.Option
                            style={{ fontSize: '16px' }}
                            value="cancelOrder"
                          >
                            {intl.formatMessage({
                              id: 'contact.cancelOrder',
                            })}
                          </Select.Option>
                          <Select.Option
                            style={{ fontSize: '16px' }}
                            value="collaboration"
                          >
                            {intl.formatMessage({
                              id: 'contact.collaboration',
                            })}
                          </Select.Option>
                          <Select.Option
                            style={{ fontSize: '16px' }}
                            value="anotherQuestion"
                          >
                            {intl.formatMessage({
                              id: 'contact.anotherQuestio',
                            })}
                          </Select.Option>
                        </Select>
                        {/* <Select
                        defaultValue="lucy"
                        style={{ width: 200 }}
                        onChange={handleChange}
                      >
                        <OptGroup label="Manager">
                          <Option value="jack">Jack</Option>
                          <Option value="lucy">Lucy</Option>
                        </OptGroup>
                        <OptGroup label="Engineer">
                          <Option value="Yiminghe">yiminghe</Option>
                        </OptGroup>
                      </Select> */}
                      </ContactSelectStyles>
                      {/* </InputWrapperStyles> */}
                    </Row>
                    <TextArea
                      borderColor="#D7D6E0"
                      width="100%"
                      padding="10px 20px"
                      // error={errors.comments ? 'has-error' : null}
                      // error={
                      //   touched.comments && errors.comments ? 'has-error' : null
                      // }
                      value={values.comments}
                      onChange={handleChange}
                      onBlur={handleBlur}
                      name="comments"
                      rows="5"
                      cols="50"
                      placeholder={intl.formatMessage({
                        id: 'forms.comments-wishes',
                      })}
                    />
                    {/* <Error touched={touched.comments} message={errors.name} /> */}
                    <ReCAPTCHA
                      sitekey="6Ld20TIaAAAAAC9oKTcslwLUT1taq-xijog_Y7uN"
                      onChange={onChange}
                    />
                    <Button
                      size="16px"
                      width="125px"
                      type="submit"
                      primary
                      disabled={isSubmitting}
                      display="block"
                      margin="29px 0"
                      marginSM="29px auto"
                      padding="9px 0"
                      size="16px"
                      sizeM="16px"
                    >
                      {intl.formatMessage({
                        id: 'buttons.send',
                      })}
                    </Button>
                  </Form>
                )}
              </Formik>
            </ContainerInner>
          </Col>
          <Col span={24} lg={10} md={10} sm={24}>
            <ContainerInner padding=" 0 0 0 80px">
              <Title margin="50px 0 0 0" weight="500" size="18px">
                {intl.formatMessage({
                  id: 'contact.email',
                })}
              </Title>
              <Title size="16px" mutedText>
                Info@aktis.villas
              </Title>
              <Title margin="50px 0 0 0" weight="500" size="18px">
                {intl.formatMessage({
                  id: 'contact.phone',
                })}
              </Title>
              <Title size="16px" mutedText>
                +30 2311 11 11 90
              </Title>
              <Title size="16px" mutedText>
                +30 693 611 9567 (Viber, WhatsApp, Telegram)
              </Title>
              {/* <Title size="16px" mutedText>
              +30 2311 000000
            </Title> */}
              <Title margin="50px 0 0 0" weight="500" size="18px">
                {intl.formatMessage({
                  id: 'contact.address',
                })}
              </Title>
              <Title
                size="16px"
                widthTablet="182px"
                marginTablet="auto"
                mutedText
              >
                22-24, Al. Ipsilantou str., 54248 Thessaloniki, Greece
              </Title>
            </ContainerInner>
          </Col>
        </Row>

        <Breadcrumb
          margin="50px 0 0 0"
          crumbs={[
            {
              title: intl.formatMessage({
                id: 'crumbs.home',
              }),
              link: '/',
            },
            {
              title: intl.formatMessage({
                id: 'crumbs.contacts',
              }),
              link: '',
            },
          ]}
        />
      </PageContainer>
    </>
  );
};

export default Contact;
